import {AddIcon, Button, ButtonIcon, ButtonText, FormGroup} from "@hosttools/frontend";
import type {Listing} from "@hosttools/frontend/models/listing";
import type React from "react";
import {memo, useCallback, useEffect} from "react";
import {useController, useFormContext} from "react-hook-form";

import useHandleArrayField from "../useHandleArrayField";

import Form from "./Form";
import Item from "./Item";

import {Table, TableHeader, TableRow} from "@/client/components/Table";

const NearbyAmenitie: React.FC = () => {
    const {control, trigger} = useFormContext<Listing>();
    const {
        fields,
        obj,
        isOpen,
        index: indexEditting,
        onOpen,
        onEdit,
        onRemove,
        onSave,
        onCancel
    } = useHandleArrayField("nearbyAmenities");
    const {
        formState: {errors}
    } = useController<Listing>({
        control,
        name: "nearbyAmenities",
        rules: {
            validate: useCallback(() => {
                if (isOpen) {
                    return "Please save or close form to continue";
                }
                return true;
            }, [isOpen])
        }
    });

    useEffect(() => {
        if (!isOpen) {
            trigger("nearbyAmenities");
        }
    }, [trigger, isOpen]);

    return (
        <FormGroup
            isInsideTab
            error={errors?.nearbyAmenities?.root?.message}
            label="Nearby Amenity"
            name="nearbyAmenities.root"
        >
            {!isOpen && (
                <Button className="self-end" variant="ghost" onPress={onOpen}>
                    <ButtonIcon as={AddIcon} />
                    <ButtonText>Amenity</ButtonText>
                </Button>
            )}
            {(fields.length > 0 || isOpen) && (
                <Table overflow="visible" size="sm">
                    <TableRow>
                        <TableHeader>Amenity</TableHeader>
                        <TableHeader>Distance</TableHeader>
                        <TableHeader align="end">Action</TableHeader>
                    </TableRow>
                    {fields.map((field, index) =>
                        indexEditting === index ? (
                            <Form
                                key={field._id}
                                item={obj}
                                onCancel={onCancel}
                                onChange={onSave}
                            />
                        ) : (
                            <Item
                                key={field._id}
                                index={index}
                                item={field}
                                onEdit={onEdit}
                                onRemove={onRemove}
                            />
                        )
                    )}
                    {isOpen && !obj && <Form onCancel={onCancel} onChange={onSave} />}
                </Table>
            )}
        </FormGroup>
    );
};

export default memo(NearbyAmenitie);
